import SubmitLoad from "./SubmitLoad";
export default SubmitLoad;